export default __webpack_public_path__ + "static/media/Love.ca592821.svg";